import { AnimateSharedLayout } from 'framer-motion'
import { useContext } from 'react'
import { useTheme } from 'styled-components'

import { Flex, Margin } from '../../components/layout'
import { Dot } from './Dot'
import { PaginatedViewContext } from './PaginatedView'

export function Pagination() {
  const { currentSlide, setCurrentSlideIndex, slides } = useContext(PaginatedViewContext)

  const theme = useTheme()
  // Wrap all the pagination dots with AnimateSharedPresence so we can detect
  // when dots with a layoutId are removed/added
  return (
    <AnimateSharedLayout>
      <Margin my={theme.UI.Spacing.Space4}>
        <Flex justifyContent='center' flexDirection='row'>
          {slides?.map((_, index) => (
            <Dot key={index} onClick={() => setCurrentSlideIndex(index)} isSelected={index === currentSlide} />
          ))}
        </Flex>
      </Margin>
    </AnimateSharedLayout>
  )
}
